export const ALERT_CONFIG = {
  target: `.fn-form-error-alert`,
  type: 'error',
  mode: 'alert',
  size: 'large',
  contentAlign: 'center',
  duration: 4000,
};
